/**
 * The /guide route: the onboarding walkthrough, on the product's own surface.
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * WORK_ORDER_M3_CONFIGURATION_AND_SURFACE.md section 4.2 screen 8. Static, designed,
 * linked from the dashboard's corner, and rendered from src/guide/guideSteps.ts so it
 * needs no markdown tooling. The same content, in the same order, is docs/user/
 * TEST_GUIDE.md; when one changes, the other changes in the same commit.
 */

import { Link } from "react-router";

import { GUIDE_STEPS } from "../guide/guideSteps";
import { strings } from "../brand/strings";

export function GuidePage(): React.JSX.Element {
  return (
    <>
      <h2 className="q-shell__heading">{strings.guide.heading}</h2>
      <p className="q-shell__lede">{strings.guide.lede}</p>
      <p className="q-note">{strings.guide.intro}</p>

      <ol className="q-thread" role="list">
        {GUIDE_STEPS.map((step) => (
          <li className="q-guide-step" key={step.n}>
            <p className="q-guide-step__count">
              {strings.guide.stepOf(step.n, GUIDE_STEPS.length)}
            </p>
            <h3 className="q-guide-step__title">{step.title}</h3>
            <p className="q-guide-step__label">
              <strong>{strings.guide.screenLabel}</strong>
              {step.screen}
            </p>
            <p className="q-guide-step__body">{step.action}</p>
            <p className="q-guide-step__label">
              <strong>{strings.guide.successLabel}</strong>
              {step.success}
            </p>
          </li>
        ))}
      </ol>

      <p className="q-row q-gap-top">
        <Link className="q-link" to="/">
          {strings.guide.backToDashboard}
        </Link>
      </p>
    </>
  );
}
